import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';

import { Section, Container, BlurredBg } from '@components/global';
import Polaroid from '@common/Polaroid';
import ScrollMotion from '@common/ScrollMotion';

import { ReactComponent as PlantOne } from '@images/art/plant-1.svg';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        image: file(
          sourceInstanceName: { eq: "polaroid" }
          name: { eq: "polaroid-about" }
        ) {
          childImageSharp {
            fluid(maxWidth: 600, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section>
        <Container>
          <Grid>
            <BlurredBg style={{ position: 'relative' }}>
              <Q>
                &nbsp;Remove heavy mineral deposits on hair and scalp caused in
                hard water/ salt-rich water areas. Remove heavy mineral deposits
                on hair and scalp caused in. Remove heavy mineral deposits on
                hair and scalp caused in hard water/ salt-rich water areas.
                Remove heavy mineral deposits on hair and scalp caused in.
                Remove heavy mineral deposits on hair and scalp caused in hard
                water/ salt-rich water areas. Remove heavy mineral deposits on
                hair and scalp caused in.
              </Q>
              <Cursive>- the illuvia team</Cursive>
              <StyledPlantOne />
            </BlurredBg>
            <div>
              <ScrollMotion
                rotate={{ start: 1.5, end: 3 }}
                translate={{ start: 0, end: -64 }}
              >
                <Polaroid fluid={data.image.childImageSharp.fluid} />
              </ScrollMotion>
            </div>
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 6rem;
`;

const Q = styled.q`
  margin-top: 3rem;
  display: block;
  ${props => props.theme.font_size.xlarge};
  color: ${props => props.theme.color.blue[2].dark};
`;

const Cursive = styled.p`
  margin-top: 2rem;
  font-family: ${props => props.theme.font.cursive};
  ${props => props.theme.font_size.large};
  color: ${props => props.theme.color.blue[2].dark};
`;

const StyledPlantOne = styled(PlantOne)`
  position: absolute;
  top: 80%;
`;

export default About;
